import { FC } from 'react'
import { createBooleanDataset } from '../../helpers'
import s from './Loading.module.css'

const Loading: FC<LoadingProps> = (props) => {
  const { icon } = props

  return <div {...createBooleanDataset({ icon })} className={s.root} />
}

type LoadingProps = {
  icon?: boolean
}

export { Loading }
export type { LoadingProps }
